module.exports = __webpack_public_path__ + "static/media/checkered-diamond-6daf50.a745fd9a.svg";